import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { db } from "./firebase";

import {
  collection,
  onSnapshot,
  getDocs,
  query,
  orderBy
} from "firebase/firestore";

const C = {
  bg: "#0a0a0f",
  surface: "rgba(255,255,255,0.04)",
  border: "rgba(255,255,255,0.08)",
  text: "#f5f5f7",
  secondary: "rgba(245,245,247,0.6)",
  green: "#30d158",
  orange: "#ff9f0a",
  red: "#ff453a",
};

export default function DemoLeads() {

  const [leads, setLeads] = useState([]);

  const [lastAccessMap, setLastAccessMap] = useState({});

  useEffect(() => {

    const unsub = onSnapshot(
      collection(db, "demoLeads"),
      (snap) => {

        const lista = snap.docs.map(d => ({
          id: d.id,
          ...d.data()
        }));

        lista.sort((a, b) => {
          const ta = a.createdAt?.seconds || 0;
          const tb = b.createdAt?.seconds || 0;
          return tb - ta;
        });

        setLeads(lista);

      }
    );

    return () => unsub();

  }, []);

  useEffect(() => {

  const loadLastAccess = async () => {

    try {

      const [
        gestoreSnap,
        menuSnap,
        asportoSnap
      ] = await Promise.all([

        getDocs(
          query(
            collection(db, "analytics_gestore"),
            orderBy("timestamp", "desc")
          )
        ),

        getDocs(
          query(
            collection(db, "analytics_menuview"),
            orderBy("timestamp", "desc")
          )
        ),

        getDocs(
          query(
            collection(db, "analytics_asporto"),
            orderBy("timestamp", "desc")
          )
        )

      ]);

      const map = {};

      [
        ...gestoreSnap.docs,
        ...menuSnap.docs,
        ...asportoSnap.docs
      ].forEach((doc) => {

        const data = doc.data();

        const locale =
          data.localeTag;

        const ts =
          data.timestamp?.seconds || 0;

        if (!locale) return;

        if (
          !map[locale] ||
          ts > map[locale]
        ) {

          map[locale] = ts;

        }

      });

      setLastAccessMap(map);

    } catch (err) {

      console.error(
        "❌ Errore ultimo accesso demo:",
        err
      );

    }

  };

  loadLastAccess();

}, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: C.bg,
        color: C.text,
        fontFamily:
          "-apple-system,BlinkMacSystemFont,sans-serif",
      }}
    >

      <Navbar />

      <div
        className="page-with-navbar"
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >

        <div style={{ marginBottom: "2rem" }}>

          <p
            style={{
              color: C.secondary,
              fontSize: "0.8rem",
              marginBottom: "0.4rem",
            }}
          >
            CRM Demo
          </p>

          <h1
            style={{
              margin: 0,
              fontSize: "2rem",
              fontWeight: 700,
            }}
          >
            📋 Lead Demo
          </h1>

        </div>

        <div
          style={{
            display: "grid",
            gap: "1rem",
          }}
        >

          {leads.map((lead) => {

            const expired =
              lead.expiresAt?.seconds * 1000 < Date.now();

            return (

              <div
                key={lead.id}
                style={{
                  background: C.surface,
                  border: `1px solid ${C.border}`,
                  borderRadius: "22px",
                  padding: "1.2rem",
                }}
              >

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "1rem",
                    flexWrap: "wrap",
                  }}
                >

                  <div>

                    <h2
                      style={{
                        margin: 0,
                        fontSize: "1.05rem",
                      }}
                    >
                      {lead.nomeLocale}
                    </h2>

                    <p
                      style={{
                        margin: "0.4rem 0 0 0",
                        color: C.secondary,
                        fontSize: "0.85rem",
                      }}
                    >
                      {lead.nome}
                    </p>

                  </div>

                  <div
                    style={{
                      background: expired
                        ? "rgba(255,69,58,0.15)"
                        : "rgba(48,209,88,0.15)",

                      color: expired
                        ? C.red
                        : C.green,

                      padding: "0.45rem 0.8rem",
                      borderRadius: "999px",
                      fontSize: "0.75rem",
                      fontWeight: 700,
                      height: "fit-content",
                    }}
                  >
                    {expired
                      ? "SCADUTA"
                      : "ATTIVA"}
                  </div>

                </div>

                <div
                  style={{
                    marginTop: "1rem",
                    display: "grid",
                    gap: "0.5rem",
                  }}
                >

                  <Info
                    label="Telefono"
                    value={lead.telefono}
                  />

                  <Info
                    label="Email"
                    value={lead.email}
                  />

                  <Info
                    label="Locale"
                    value={lead.localeTag}
                  />

                  <Info
  label="Registrazione"
  value={
    lead.createdAt?.seconds
      ? new Date(
          lead.createdAt.seconds * 1000
        ).toLocaleString("it-IT")
      : "-"
  }
/>

<Info
  label="Ultimo accesso"
  value={
    lastAccessMap[lead.localeTag]
      ? new Date(
          lastAccessMap[lead.localeTag] * 1000
        ).toLocaleString("it-IT")
      : "Mai"
  }
/>



                </div>

              </div>

            );

          })}

        </div>

      </div>

    </div>
  );
}

function Info({ label, value }) {

  return (

    <div>

      <div
        style={{
          fontSize: "0.72rem",
          color: "rgba(255,255,255,0.45)",
          marginBottom: "0.15rem",
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize: "0.9rem",
        }}
      >
        {value || "-"}
      </div>

    </div>

  );

}